<template>
  <div class="selector">
    <v-select
      v-model="lang"
      :options="languages"
      :clearable="false"
      :searchable="false"
      :reduce="(lang) => lang.value"
      @input="selectLang()"
    />

  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: null,
    };
  },

  computed: {
    languages() {
      return this.$store.state.languages;
    },

    fallback_lang() {
      this.$store.state.fallback_lang;
    },
  },

  methods: {
    selectLang() {
      this.$store.commit("set_app_loading", true);

      var vue = this;

      axios({
        method: "post",
        url: window.location.origin + "/set-language",
        data: {
          lang: vue.lang,
        },
      })
        .then((res) => {
          // console.log(res.data)
          window.location.reload();
        })
        .catch(() => {
          this.$store.commit("set_app_loading", false);
        });
    },
  },

  mounted() {
    this.lang = this.$store.state.current_lang
      ? this.$store.state.current_lang
      : this.$store.state.fallback_lang;
  },
};
</script>

<style scoped>
.selector {
  width: 100%;
  max-width: 80px;
  display: flex;
  align-items: center;

}
.selector >>> svg {
  margin-left: 10px;
}
.selector >>> .vs__search {
  opacity: 0;
}
.selector >>> .vs__dropdown-toggle {
  border: none;
  padding: 0;
}
.selector >>> .vs__selected {
  color: white;
  margin: 0;
  position: relative;
  padding: 0;
}
.selector >>> .vs__selected-options {
  flex-wrap: unset;
  padding: 0;
}
.selector >>> .vs__actions {
  padding: 0;
}
.selector >>> .vs__open-indicator {
  fill: white;

}
.selector >>> .vs__search {
  margin: 0;

}
.selector >>> .vs__dropdown-menu {
  min-width: 20px;
  background-color: white;

  border: none;
}
.selector >>> .vs__dropdown-option {
  margin: 0 !important;
  padding: 10px;
  color: var(--black);
}
.selector >>> .vs__dropdown-option--highlight {
  background-color: var(--dark-gray);
  color: white;
}
@media (min-width: 1921px) {
  .selector {

  }
  .selector >>> .vs__open-indicator {

  }
}
</style>
